// ============================================
// FILE: src/pages/supplier/Products.jsx
// ============================================
// NOTE: Product/Service management has been DISABLED.
// Suppliers' products/services are now managed via their registration profile.
// All CRUD operations below are commented out for future re-enablement.
// ============================================
import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import Navbar from '../../components/Navbar';

const SupplierProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // DISABLED: Form state for add/edit product
  // const [showForm, setShowForm] = useState(false);
  // const [editingProduct, setEditingProduct] = useState(null);
  // const [formData, setFormData] = useState({
  //   name: '',
  //   description: '',
  //   price: '',
  //   discountPrice: '',
  //   unit: '',
  //   stockQuantity: '',
  //   minOrderQuantity: '1',
  //   categoryId: ''
  // });

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/supplier/products`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setProducts(data.success ? data.products : data);
      } else {
        console.log('Products API error:', response.status, response.statusText);
        toast.error('Failed to load products');
      }
    } catch (error) {
      toast.error('Error loading products');
    }
    setLoading(false);
  };

  // DISABLED: handleSubmit - Add/Edit product
  // const handleSubmit = async (e) => { ... };

  // DISABLED: handleEdit - Edit product
  // const handleEdit = (product) => { ... };

  // DISABLED: handleDelete - Delete product
  // const handleDelete = async (productId) => { ... };

  // DISABLED: toggleActive - Toggle product active status
  // const toggleActive = async (product) => { ... };

  return (
    <div className="min-h-screen">
      <Navbar userType="supplier" />

      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8 pt-28">
        <div className="px-4 py-6 sm:px-0">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-3xl font-bold text-gray-900">My Products &amp; Services</h1>
            {/* DISABLED: Add Product button - product management is now via registration profile */}
            {/* <button
              onClick={() => setShowForm(true)}
              className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg font-medium"
            >
              Add Product
            </button> */}
          </div>

          {/* Informational Banner */}
          <div className="mb-6 bg-blue-50 border-l-4 border-blue-500 rounded-lg p-4 flex items-start space-x-3">
            <div className="flex-shrink-0 mt-0.5">
              <svg className="h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-blue-800">Product &amp; Service Management</h3>
              <p className="text-sm text-blue-700 mt-1">
                Adding and editing products/services is currently managed through your <strong>business registration profile</strong>.
                Customers searching for products or services will find your business based on the details you provided during registration.
              </p>
            </div>
          </div>

          {loading ? (
            <div className="text-center py-12">Loading...</div>
          ) : products.length === 0 ? (
            <div className="text-center py-12 bg-white rounded-lg shadow">
              <div className="text-gray-400 text-5xl mb-4">📦</div>
              <h3 className="text-lg font-medium text-gray-700">No products listed yet</h3>
              <p className="text-sm text-gray-500 mt-2">
                Your products and services from your registration profile will appear here.
              </p>
            </div>
          ) : (
            <div className="bg-white shadow overflow-hidden sm:rounded-md">
              <ul className="divide-y divide-gray-200">
                {products.map((product) => (
                  <li key={product.id} className="px-6 py-4">
                    <div className="flex items-center justify-between">
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center">
                          <div className="flex-1 min-w-0">
                            <p className="text-sm font-medium text-gray-900 truncate">
                              {product.name}
                            </p>
                            <p className="text-sm text-gray-500 truncate">
                              ₹{product.price} {product.unit && `per ${product.unit}`}
                            </p>
                            <p className="text-xs text-gray-400">
                              Stock: {product.stock_quantity} | Min Order: {product.min_order_quantity}
                            </p>
                          </div>
                          {/* DISABLED: Edit / Deactivate / Delete buttons */}
                          {/* <div className="ml-4 flex-shrink-0 flex space-x-2">
                            <button onClick={() => handleEdit(product)} className="text-indigo-600 hover:text-indigo-900 text-sm">Edit</button>
                            <button onClick={() => toggleActive(product)} className={`text-sm ${product.is_active ? 'text-red-600 hover:text-red-900' : 'text-green-600 hover:text-green-900'}`}>
                              {product.is_active ? 'Deactivate' : 'Activate'}
                            </button>
                            <button onClick={() => handleDelete(product.id)} className="text-red-600 hover:text-red-900 text-sm">Delete</button>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* DISABLED: Add/Edit Product Form Modal */}
          {/* {showForm && (
            <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
              ... form content ...
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default SupplierProducts;